import { useMemo } from "react";
import { useLocaleContext } from "./LocaleContext";
import messages, { type MessageKey } from "./messages";
import type { Locale } from "./locales";

/**
 * Returns a `t(key, params?)` function for the current URL-driven locale.
 * Supports simple interpolation: `{time}`, `{value}`, etc.
 */
export function useT() {
  const locale: Locale = useLocaleContext();

  return useMemo(() => {
    const dict = messages[locale];
    const fallback = messages.en;

    function t(key: MessageKey, params?: Record<string, string | number>): string {
      let text: string = (dict as Record<string, string>)[key] ?? (fallback as Record<string, string>)[key] ?? key;
      if (params) {
        for (const [k, v] of Object.entries(params)) {
          text = text.replace(`{${k}}`, String(v));
        }
      }
      return text;
    }

    return { t, locale };
  }, [locale]);
}
